import { useContext } from 'react';
import { connect } from 'react-redux';
import Icon from '../../../atoms/icon';
import PropTypes from 'prop-types';
import { fetchNetGrossDisclosuresData } from '../../../../stores/screener/actions/row-documents-disclosures-actions';
import screenerAppContext from '../../../../stores/screener/screener-app-context';
import styles from './net-gross-disclosure-button.module.scss';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

export const NetGrossDisclosureButton = ({
  setModal,
  xid,
  item,
  getNetGrossDisclosure,
  netGrossDisclosures
}) => {
  const { yyy, channel } = useContext(screenerAppContext);
  const showNetGrossDisclosure = async () => {
    const disclosure = await getNetGrossDisclosure(xid, item, yyy, channel);
    if (netGrossDisclosures[xid] || disclosure) {
      setModal('Disclosure', netGrossDisclosures[xid] || disclosure);
    }
  };

  return (
    <>
      <Icon
        placeholder="disclosure"
        aria-label="Net Gross Disclosure"
        variant="disclosureScreenerBlue"
        {...className('net-gross-icon')}
        onClick={async e => {
          e.stopPropagation();
          await showNetGrossDisclosure();
        }}
      />
    </>
  );
};

NetGrossDisclosureButton.propTypes = {
  setModal: PropTypes.func,
  xid: PropTypes.number,
  item: PropTypes.object,
  getNetGrossDisclosure: PropTypes.func,
  netGrossDisclosures: PropTypes.object
};

NetGrossDisclosureButton.defaultProps = {
  netGrossDisclosures: {}
};

const mapDispatchToProps = dispatch => {
  return {
    getNetGrossDisclosure: (xid, item, yyy, channel, isForNetGross) =>
      dispatch(fetchNetGrossDisclosuresData(xid, item, yyy, channel, isForNetGross))
  };
};

const mapStateToProps = state => {
  return {
    netGrossDisclosures: state.rowDocsAndDisclosuresReducer.netGrossDisclosures
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NetGrossDisclosureButton);
